export enum WithdrawalType {
  NoWithdrawal = 'NoWithdrawal',
  WithdrawalMade = 'WithdrawalMade',
}

export enum CommentType {
  VoterComment = 'VoterComment',
  RejectHandlingComment = 'RejectHandlingComment',
}

export enum CommentActionType {
  AlreadyAddressed = 'AlreadyAddressed',
  NoFurtherAction = 'NoFurtherAction',
  ReferToTaskForce = 'ReferToTaskForce',
  NewBusiness = 'NewBusiness',
  EditorialChange = 'EditorialChange',
}

export enum CommentCaseType {
  NoVote = 'NoVote',
  Voted = 'Voted',
}

export enum RelatedType {
  Related = 'Related',
  NotRelated = 'NotRelated',
}

export enum PersuasiveType {
  Persuasive = 'Persuasive',
  NotPersuasive = 'NotPersuasive',
}

export enum SignificantType {
  Significant = 'Significant',
  NotSignificant = 'NotSignificant',
  VoteToDetermine = 'VoteToDetermine',
}

export enum ApprovalLevelType {
  GloballyApproved = 'GloballyApproved',
  NeedsRatification = 'NeedRatification',
}

export enum SafetyMotionType {
  SafetyDocument = 'SafetyDocument',
  NotSafetyDocument = 'NotSafetyDocument',
}

export enum IPCheckType {
  Affirmative = 'Affirmative',
  NotAffirmative = 'NotAffirmative',
}

export enum TechnologyType {
  Patent = 'Patent',
  Copyright = 'Copyright',
}

export enum IPCheckMotionType {
  AskPermission = 'AskForPermission',
  QuitActivity = 'QuitActivity',
  Wait = 'Wait',
}

export enum QuestionResponse {
  Yes = 'Yes',
  No = 'No',
}

export enum FinalActionType {
  Passed = 'PassedAndForwarded',
  PassedWithEditorialChanges = 'PassedWithEditorialChanges',
  PassedWithTechnicalChanges = 'PassedWithTechnicalChanges',
  FailedAndReturned = 'FailedAndReturned',
  FailedAndDiscontinued = 'FailedAndDiscontinued',
}

export enum ActivityType {
  Motion = 'Motion',
  Document = 'Document',
  Reject = 'Reject',
  TechnicalIssue = 'TechnicalIssue',
  Comment = 'Comment',
  IpCheck = 'IpCheck',
  Approval = 'Approval',
  Connection = 'Connection',
}

export enum ItemType {
  Document = 'Document',
  Reject = 'Reject',
  TechnicalIssue = 'Technical Issue',
  Comment = 'Comment',
  Motion = 'Motion',
}

export enum ConfirmationType {
  Overwrite = 'Overwrite',
  Delete = 'Delete',
}
